<div class="rx-card order-information"
	 [class.read-only]="isReadOnly$ | async" [class.invalid-for-send]="isInvalidForSend$ | async">
	<div class="rx-card-title">
		<div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--align-center">
			<div class="order-information-title">{{ 'OrderInformation.OrderInformation' | translate }}</div>
		</div>
	</div>
	<div class="rx-card-body">
		<form class="rx-app-flex-container-row" [formGroup]="orderInformationForm">
			<div
				class="abutment-section order-information__section rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--justify-space-between"
			>
				<div class="order-information__column">
					<tlk-checkbox
						id="auto-local-export-ide-checkbox"
						[formControl]="localExportIdeControl"
						name="localExportIdeControl"
					>
						{{ 'OrderInformation.LocalExportIDE' | translate }}
					</tlk-checkbox>
					<div class="local-export-ide-info-container" *ngIf="!!localExportIdeControl.value">
						<rx-select
							id="auto-cad-cam-systems-selector"
							class="mt-4"
							[label]="'OrderInformation.CadCamSystem' | translate"
							[formControl]="cadCamSystemControl"
							[options]="cadCamSystemOptions$ | async"
							name="cadCamSystemControl"
						>
						</rx-select>
					</div>
				</div>
				<div *ngIf="isPhysicalModelOrderVisible$ | async" class="order-information__column">
					<tlk-checkbox
						id="auto-physical-model-order-checkbox"
						[formControl]="physicalModelOrderControl"
						name="physicalModelOrderControl"
					>
						{{ 'OrderInformation.PhysicalModelOrder' | translate }}
					</tlk-checkbox>
					<div class="physical-model-info-container" *ngIf="!!physicalModelOrderControl.value">
						<tlk-incremental-number-input
							id="auto-no-of-models-incremental-selector"
							class="mb-4 mt-4"
							[formControl]="numberOfModelsControl"
							[label]="'OrderInformation.NoOfModels' | translate"
							[min]="0"
							name="numberOfModelsControl"
						>
						</tlk-incremental-number-input>
						<tlk-incremental-number-input
							id="auto-additional-dies-incremental-selector"
							class="mb-4"
							[formControl]="additionalDiesControl"
							[label]="'OrderInformation.AdditionalDies' | translate"
							[min]="0"
							name="additionalDiesControl"
						>
						</tlk-incremental-number-input>
						<tlk-checkbox
							id="auto-die-ditch-checkbox"
							[formControl]="dieDitchControl"
							name="dieDitchControl"
						>
							{{ 'OrderInformation.DieDitch' | translate }}
						</tlk-checkbox>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
